import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { MODULE_NAME } from '../utils/constants';

export const useWishlistSave = ({ apiUrl, conversationId, track }) => {
  const selectedHotels = useSelector((state) => state.getIn(['modules', MODULE_NAME, 'selectedHotels'])
  ).toJS();

  const [createModalIsOpen, setCreateModalIsOpen] = useState(false);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isSaveSuccess, setIsSaveSuccess] = useState(false);

  const saveSelectedHotels = useCallback(async () => {
    setIsSaveLoading(true);
    track({
      event: {
        identifier: 'axp - WishlistBuilder - Chat',
        element: 'CreateWishlist',
        type: 'click',
      },
    });

    const payload = {
      conversation_id: conversationId,
      selected_hotels: selectedHotels.map((hotel) => ({
        hotel_id: hotel.hotelId,
        name: hotel.name,
        address: hotel.address || null,
        description: hotel.description || null,
      })),
    };

    try {
      const response = await fetch(`${apiUrl}/save`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          x_amex_tracking_id: uuidv4(),
          x_conversation_id: conversationId,
        },
        body: JSON.stringify(payload),
      });

      const resJSON = await response.json();
      setIsSaveSuccess(true);
      setIsSaveLoading(false);

      const wishlist = resJSON.wishlist_id;
      const deeplink = `amextravel://wishlist?wishlistId=${wishlist}&conversationId=${conversationId}`;
      window.location.href = deeplink;
    } catch {
      setIsSaveSuccess(false);
    }
  }, [apiUrl, conversationId, selectedHotels, track]);

  return {
    selectedHotels,
    createModalIsOpen,
    setCreateModalIsOpen,
    saveSelectedHotels,
    isSaveSuccess,
    isSaveLoading,
  };
};
